import Button from '@/components/Buttons/Button';
import { useGetSupportUrl } from '@/hooks/useGetSupportUrl';
import styled from '@emotion/styled';
import { Popover, PopoverPosition, Typography } from '@mui/material';

const styles = {
    paper: {
        width: '241px',
        padding: '16px',
        boxShadow: '5.3px 13.3px 18.8px -1.2px rgba(187, 187, 187, 0.29) !important',
        pointerEvents: 'auto',
        userSelect: 'none',
    },
};

const Title = styled(Typography)`
    margin-bottom: 0.8rem;
    letter-spacing: -0.04rem;
`;

const ButtonContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 1rem;
`;

const ContactButton = styled(Button)`
    font-size: 1.4rem;
    height: 3.4rem;
    padding-left: 0.8rem;
    padding-right: 0.8rem;
`;

interface Props {
    anchorPosition: PopoverPosition;
    open: boolean;
    onMouseEnter: () => void;
    onMouseLeave: () => void;
}

export default function ProofreadUpgradePopup({ open, anchorPosition, onMouseEnter, onMouseLeave }: Props) {
    const supportUrl = useGetSupportUrl();

    const handleClick = () => {
        window.open(supportUrl);
    };

    return (
        <Popover
            disableRestoreFocus
            anchorReference="anchorPosition"
            sx={{ pointerEvents: 'none' }}
            slotProps={{ paper: { sx: styles.paper, onMouseEnter, onMouseLeave } }}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            transformOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            open={open}
            anchorPosition={anchorPosition}>
            <Title variant="h4">Edit translations</Title>
            <Typography variant="h5" fontWeight={600}>
                Translation editing is available
                <br />
                on our Enterprise plan
            </Typography>
            <ButtonContainer>
                <ContactButton color="secondary" onClick={handleClick}>
                    Contact us
                </ContactButton>
            </ButtonContainer>
        </Popover>
    );
}
